import React from 'react';
import { Select } from '../../components/Primitives.jsx';
import { SOURCE_COLUMNS } from '../../data.js';
import { ColumnsContext } from '../StepInspector.jsx';

// ── Tiny helpers (shared across inspectors) ────────────────────────────
export function ColSelect({ value, onChange, columns, placeholder = '— pick a column —', style }) {
  const ctxCols = React.useContext(ColumnsContext);
  const cols = columns || ctxCols || SOURCE_COLUMNS;
  return (
    <Select
      value={value || ''}
      onChange={onChange}
      options={[{ value: '', label: placeholder }, ...cols.map(c => ({ value: c.name, label: `${c.name} · ${c.type}` }))]}
      style={style}
    />
  );
}
